import locationHttpService from '../../../../frontend/global/modules/Locations/services/locationHttpService';
import { ApiCall } from '../../services/http-service/types/ApiCall';
import { FetchOverhaulLocationsParams } from './types/FetchOverhaulLocationsParams';
import { ReverseGeocodeParams } from './types/ReverseGeocodeParams';
import { OverhaulLocation } from './types/OverhaulLocation';
import { DirectionParams } from './types/DirectionParams';
import { DirectionsData } from './types/DirectionsData';
import { GeocodeParams } from './types/GeocodeParams';
import { GeocodedData } from './types/GeocodedData';
import { Country } from './types/Country';

export const getCountries: ApiCall<undefined, Country[]> = async ({ abortSignal }) => {
  const { data } = await locationHttpService.get('/api/v1/countries', null, abortSignal);
  return data;
};

export const getDirections: ApiCall<DirectionParams, DirectionsData> = async ({ params, abortSignal }) => {
  const preparedCoordinates = params.coordinates.map((point) => point.join(',')).join(';');

  const { data } = await locationHttpService.get(
    `/api/v1/external/segments/suggest/${preparedCoordinates}`,
    { delivery_type: params.delivery_type },
    abortSignal
  );

  return data;
};

export const getExternalLocations: ApiCall<GeocodeParams | ReverseGeocodeParams, GeocodedData[]> = async ({ params, abortSignal }) => {
  try {
    const { data } = await locationHttpService.get('/api/v1/external/locations/search', params, abortSignal);
    return data;
  } catch (err) {
    return [];
  }
};

export const getOverhaulLocations: ApiCall<FetchOverhaulLocationsParams, { data: OverhaulLocation[]; headers: { total: number } }> = async ({ params, abortSignal }) => {
  const { data, headers } = await locationHttpService.get('/api/v1/locations/filter_aggs', params, abortSignal);

  return { data, headers: { total: Number(headers.total) } };
};
